import type { Point, PointArray } from '../types/contour-definition-array-type';

/**
 * Checks if a point is inside a polygon using the ray casting algorithm
 */
export function isPointWithinPolygon(
  point: Point,
  polygon: PointArray,
): boolean {
  // If polygon has fewer than 3 points, it's not a proper polygon
  if (polygon.length < 3) {
    return false;
  }

  let inside = false;
  const { x, y } = point;

  // Loop through all edges of the polygon
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;

    // Check if ray intersects with the edge
    const intersect
      = (yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) {
      inside = !inside;
    }
  }

  return inside;
}
